// @ts-ignore
import { validators } from 'vue-form-generator';

import { defaults } from 'lodash';

let resources = {
   fieldIsRequired: 'This field is required!',
   invalidFormat: 'Invalid format!',

   numberTooSmall: 'The number is too small! Minimum: {0}',
   numberTooBig: 'The number is too big! Maximum: {0}',
   invalidNumber: 'Invalid number',
   invalidInteger: 'The value is not an integer',

   textTooSmall: 'The length of text is too small! Current: {0}, Minimum: {1}',
   textTooBig: 'The length of text is too big! Current: {0}, Maximum: {1}',
   thisNotText: 'This is not a text!',

   thisNotArray: 'This is not an array!',

   selectMinItems: 'Select minimum {0} items!',
   selectMaxItems: 'Select maximum {0} items!',

   invalidDate: 'Invalid date!',
   dateIsEarly: 'The date is too early! Current: {0}, Minimum: {1}',
   dateIsLate: 'The date is too late! Current: {0}, Maximum: {1}',

   invalidEmail: 'Invalid e-mail address!',
   invalidURL: 'Invalid URL!',

   invalidCard: 'Invalid card format!',
   invalidCardNumber: 'Invalid card number!',

   invalidTextContainNumber: 'Invalid text! Cannot contains numbers or special characters',
   invalidTextContainSpec: 'Invalid text! Cannot contains special characters',
};

export default {
   resources,

   required(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.required(value, field, model, defaults(messages, resources));
   },

   number(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.number(value, field, model, defaults(messages, resources));
   },

   integer(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.integer(value, field, model, defaults(messages, resources));
   },

   double(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.double(value, field, model, defaults(messages, resources));
   },

   string(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.string(value, field, model, defaults(messages, resources));
   },

   array(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.array(value, field, model, defaults(messages, resources));
   },

   date(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.date(value, field, model, defaults(messages, resources));
   },

   regexp(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.regexp(value, field, model, defaults(messages, resources));
   },

   email(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.email(value, field, model, defaults(messages, resources));
   },

   url(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.url(value, field, model, defaults(messages, resources));
   },

   creditCard(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.creditCard(value, field, model, defaults(messages, resources));
   },

   alpha(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.alpha(value, field, model, defaults(messages, resources));
   },

   alphaNumeric(value: any, field: any, model: any, messages: any | undefined = undefined) {
      return validators.alphaNumeric(value, field, model, defaults(messages, resources));
   },
};
